var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09433 8.90411H1.86036L6.57965 4.17808L5.81362 3.41096L1.09433 8.13699V8.90411ZM8.91878 3.38356L6.59333 1.08219L7.35936 0.315069C7.56911 0.105023 7.82682 0 8.13251 0C8.43819 0 8.69572 0.105023 8.9051 0.315069L9.67113 1.08219C9.88088 1.29224 9.99031 1.54575 9.99943 1.84274C10.0085 2.13973 9.90824 2.39306 9.69849 2.60274L8.91878 3.38356ZM0.547166 10C0.392136 10 0.262094 9.9474 0.157038 9.84219C0.0519825 9.73699 -0.000362883 9.60694 1.8933e-06 9.45205V7.90411C1.8933e-06 7.83105 0.013681 7.76018 0.0410392 7.69151C0.0683975 7.62283 0.109435 7.56128 0.164151 7.50685L5.79994 1.86301L8.12539 4.19178L2.4896 9.83562C2.43488 9.89041 2.37342 9.93151 2.30521 9.9589C2.23699 9.9863 2.16623 10 2.09291 10H0.547166ZM6.19664 3.79452L5.81362 3.41096L6.57965 4.17808L6.19664 3.79452Z",
    fill: "#5382ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencile);
export default __webpack_public_path__ + "static/media/pencile.a3a6d0aefbb2fae3e5d15d1cb8a92c2e.svg";
export { ForwardRef as ReactComponent };